module.exports = __webpack_public_path__ + "media/images/lb/154-5c798f43aa1dcd8ca7cd5bb7fe25a580.svg";